<template>
  <v-dialog
    :value="show"
    :fullscreen="false"
    content-class="force-no-margins-dialog"
    :width="dialogWidth"
    lazy
    @input="(val) => $emit('update:show', val)"
  >
    <v-fade-transition>
      <v-card
        v-if="show"
        :key="spot.id"
        :style="{overflow: 'hidden'}"
      >
        <div :style="{height: dialogHeight + 'px'}">
          <tv-template-preview
            ref="preview"
            :html-overlay="spot.editable_template.html_overlay"
            :background-image="
              !spot.editable_template.use_tvspot_video_for_background &&
                spot.editable_template.use_tvspot_poster_for_preview_background
                ? spot.editable_template.video_poster_for_editing
                : null
            "
            :background-video="
              spot.editable_template.use_tvspot_video_for_background
                ? spot.preview_url
                : null
            "
            :width="tvformat.width"
            :height="tvformat.height"
            :max-width="dialogWidth"
            :max-height="dialogHeight"
            :is-multiscreen="tvformat.is_multiscreen_format"
            :duration="spot.duration"
            :fake-player-progress="spot.editable_template.is_animated"
            :fade-color="
              spot.editable_template.dummy_video_for_background_color
            "
            :fake-fade-in-fade-out="spot.editable_template.fade_enabled"
            :fade-in-start="spot.editable_template.fadein_start"
            :fade-in-stop="spot.editable_template.fadein_stop"
            :fade-out-start="spot.editable_template.fadeout_start"
            :fade-out-stop="spot.editable_template.fadeout_stop"
            :onload-callback="() => populateIframeWithPreviewOverlayData()"
          />
        </div>
        <div
          v-if="
            spot.editable_template && !loading && !allEntriesUseSameOverlayData
          "
          class="py-1 px-2 grey--text text--darken-2"
          :class="{caption: $vuetify.breakpoint.xs}"
        >
          <i18n path="editableTemplateDifferentOverlayDataDialogHint">
            <!--
              Slot 0 used here by position, as for some reason named
              slots won't work here, see:
              https://kazupon.github.io/vue-i18n/guide/interpolation.html#basic-usage
            -->
            <router-link
              :to="{
                name: 'spot',
                params: {ctype: 'tv', spotId: spot.bundle_id},
              }"
              style="display: inline-block"
            >
              {{ $t('spotDetailPage') }}
            </router-link>
          </i18n>
        </div>
      </v-card>
    </v-fade-transition>
  </v-dialog>
</template>

<script>
import {deepCopyObject} from '@/utils';

import {applyBrandingToOverlayDataBrandableFields} from '@/mixins/overlayOptions.js';

import TvTemplatePreview from '@/components/TvTemplatePreview';

export default {
  components: {
    TvTemplatePreview,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    dialogWidth: {
      type: Number,
      required: true,
    },
    dialogHeight: {
      type: Number,
      required: true,
    },
    /** The editable TVSpot to preview. */
    spot: {
      type: Object,
      required: true,
    },
    tvformat: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      overlayData: null,
      allEntriesUseSameOverlayData: true,
    };
  },
  computed: {
    differentOverlayDataHintMarkdown() {
      if (!this.spot) {
        return '';
      }
      return this.$t('editableTemplateDifferentOverlayDataDialogHint', {
        link: '/app/content/tv/' + spot.bundle_id,
      });
    },
  },
  methods: {
    populateIframeWithPreviewOverlayData() {
      this.fetchPreviewOverlayData().then(() => {
        const previewWidget = this.$refs.preview;
        previewWidget.updateOverlayData(this.overlayData);
      });
    },
    injectBrandingIntoOverlayData(branding, overlayData) {
      overlayData.branding = deepCopyObject(branding);
    },
    fetchPreviewOverlayData() {
      this.loading = true;
      return this.$api
        .getOverlayDataForHtmlPreview(this.spot)
        .then((response) => {
          const overlayData = response.data.overlay_data;

          // If we have a lastBrandingApplied, use that instead of what
          // we get initially, to better match what the User would
          // expect.
          if (
            this.spot.editable_template &&
            this.spot.editable_template.is_brandable
          ) {
            const branding = this.$store.state.common.lastBrandingApplied;
            if (branding) {
              this.injectBrandingIntoOverlayData(branding, overlayData);
              applyBrandingToOverlayDataBrandableFields(
                branding,
                this.spot.overlay_options,
                overlayData
              );
            }
          }

          this.overlayData = overlayData;
          this.allEntriesUseSameOverlayData =
            response.data.all_entries_use_same_overlay_data;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
.v-dialog--active.force-no-margins-dialog {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniPreviewHtmlDialog.vue